import React from 'react';
import { Route, Switch } from "react-router-dom";
import '../common/css/global.css';
import './App.css';
import LandingPage from "./Pages/LandingPage";
import OffsetPage from "./Pages/OffsetPage";
import ImpactPage from "./Pages/ImpactPage";
import LearnMorePage from "./Pages/LearnMorePage";

function App() {
  const merchantCode = 'BES_NZ_FORTIS';

  return (
    <>

      <Switch>
        <Route
          path={`/`}
          key="app-fortis-landing"
        >
          <LandingPage merchantCode={merchantCode} />
        </Route>
      </Switch>

    </>
  );
}

export default App;
